"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.filter");

var _throttle = _interopRequireDefault(require("lodash-es/throttle"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Create a 'Infinite Scroll Memory' object.
 * @param {object} config - Settings object defined when instantiating.
 */


var _default = function _default() {
  var config = {
    delay: 250,
    storageNamespace: 'mbScrollY',
    throttle: 250
  };
  var storedScroll = window.sessionStorage.getItem(config.storageNamespace);

  var eligibleLinks = _toConsumableArray(document.querySelectorAll('a[href]')).filter(function (link) {
    return /(\/products\/)|(\/cart)/.test(link.href) ? null : link;
  });
  /**
   * Initialise component.
   */


  function init() {
    checkSessionScroll();
    setEventListeners();
  }
  /**
   * Set event listeners.
   */


  function setEventListeners() {
    /**
     * On window scroll, store the scroll distance.
     */
    (0, _utils.on)('scroll', (0, _throttle["default"])(function () {
      window.sessionStorage.setItem(config.storageNamespace, window.scrollY);
    }, config.throttle));
    /**
     * Handle non-product linkd.
     */

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = eligibleLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var link = _step.value;
        (0, _utils.on)('click', link, function (event) {
          event.preventDefault();
          handleEligibleLinkClick(event);
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  /**
   * Check for session scroll height and scroll there.
   */


  function checkSessionScroll() {
    window.setTimeout(function () {
      handleScrollTo();
    }, config.delay);
  }
  /**
   * Function to scroll to a specific area.
   *
   */


  function handleScrollTo() {
    if (storedScroll == null || storedScroll === 0) {
      return;
    }

    var duration = storedScroll / 8;
    var startingY = window.pageYOffset;
    var diff = storedScroll - startingY;
    var start;
    window.requestAnimationFrame(function step(timestamp) {
      if (!start) {
        start = timestamp;
      }

      var time = timestamp - start;
      var percent = Math.min(time / duration, 1);
      window.scrollTo(0, startingY + diff * percent);

      if (time < duration) {
        window.requestAnimationFrame(step);
      }

      removeStoredScroll();
    });
  }
  /**
   * If the user clicks a link that isn't a product, remove the
   * stored scroll distance to prevent unnecessary scrolling.
   * @param {Object} event - click event.
   */


  function handleEligibleLinkClick(event) {
    if (!event) {
      return;
    }

    removeStoredScroll();
    var link = event.currentTarget;
    window.setTimeout(function () {
      window.location.href = link.href;
    }, config.delay);
  }
  /**
   * Helper function to remove the stored item.
   */


  function removeStoredScroll() {
    window.sessionStorage.removeItem(config.storageNamespace);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;